module.exports = __webpack_public_path__ + "media/images/icons/flags/SL-a3027f8683de4e2379cf54ab9fb8c9ad.svg";